import React, { useCallback } from 'react';
import { View } from 'react-native';
import { Button, CardView, rem, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import { IconRocket } from 'design-system/icons/IconRocket';
import IconStatusPending from 'design-system/icons/status/IconStatusPending';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatDateForItem } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const PendingAutoinvestCard = ({ activity, containerStyle }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const handlePress = useCallback(() => {
        navigation.navigate('AutoinvestActivityTimeline', { activity });
    }, [activity]);
    return (<CardView noMarginTop noMarginBottom withPadding style={[containerStyle && { borderRadius: 0 }, containerStyle]}>
      <View style={styles.row}>
        <View style={styles.iconContainer}>
          <IconRocket colorKey="brand"/>
        </View>
        <Spacer.W16 />
        <View style={styles.flex}>
          <View style={styles.row}>
            <View style={styles.flex}>
              <Text Text-16>Autoinvest</Text>
              <View style={styles.row}>
                <IconStatusPending width={16} height={16} color={colors.cards.onDark} bgColor={colors.elements.statusInformational}/>
                <Spacer w={8}/>
                <Text TextThin-14 StatusInformational numberOfLines={1}>
                  Pending
                </Text>
              </View>
            </View>
            <View style={styles.rightContent}>
              <Amount showSign Numbers-16 value={activity.amount} color={colors.text.income}/>
              <Text TextThin-14 Secondary>
                {formatDateForItem(new Date(activity.timestamp))}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <Spacer h={24}/>
      <Button square brandReversed title="Track payment" onPress={handlePress}/>
    </CardView>);
};
const styleSet = createStyleSheets((colors) => ({
    flex: {
        flex: 1,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    iconContainer: {
        width: rem(42),
        height: rem(42),
        borderWidth: rem(1),
        borderRadius: rem(42),
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.brandLight,
    },
    rightContent: {
        alignItems: 'flex-end',
    },
}));
export default PendingAutoinvestCard;
